export enum AttachmentTypes {
  File = 1,
  URL = 2
}
